import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "step",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_2 = {
  "data-aos": "slide-left",
  "data-aos-easing": "ease"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_4 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_5 = {
  "data-aos": "slide-left",
  "data-aos-easing": "ease"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createElementVNode("b", _hoisted_2, _toDisplayString(_ctx.name) + " - " + _toDisplayString(_ctx.extraDetails), 1),
      _hoisted_3,
      _createElementVNode("sub", _hoisted_4, _toDisplayString(_ctx.year), 1)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.content), 1)
  ]))
}